// extracted by mini-css-extract-plugin
export default {"card-body":"card-body_card-body__6GQH0"};